export default __webpack_public_path__ + "static/media/A0006.752250f6.png";